var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoreHorizontal(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more_horiz_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/navigation/more_horiz_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9287 4.5C10.9287 3.675 10.2537 3 9.42871 3C8.60371 3 7.92871 3.675 7.92871 4.5C7.92871 5.325 8.60371 6 9.42871 6C10.2537 6 10.9287 5.325 10.9287 4.5ZM10.9287 13.5C10.9287 12.675 10.2537 12 9.42871 12C8.60371 12 7.92871 12.675 7.92871 13.5C7.92871 14.325 8.60371 15 9.42871 15C10.2537 15 10.9287 14.325 10.9287 13.5ZM9.42871 7.5C10.2537 7.5 10.9287 8.175 10.9287 9C10.9287 9.825 10.2537 10.5 9.42871 10.5C8.60371 10.5 7.92871 9.825 7.92871 9C7.92871 8.175 8.60371 7.5 9.42871 7.5Z",
    fill: "black",
    fillOpacity: 0.54
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreHorizontal);
export default __webpack_public_path__ + "static/media/more-horizontal.2cdf94c5.svg";
export { ForwardRef as ReactComponent };